// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUserBookingStatus {
  /** Тип статуса **/
  type: EType;
  /** Описание состояния отображаемое для пользователя **/
  description?: TUserBookingStatus_Description;
}

export enum EType {
  /** Нет активных записей **/
  'NoActive' = 'noActive',
  /** Есть активная запись **/
  'SignedUp' = 'signedUp',
}
export type TUserBookingStatus_Description = null | string;
